<template>
    <div class="bo-mode-input-number">
        <bo-dropdown-menu
            v-if="before"
            :disabled="!editable"
            :options="options"
            :dropdownStyle="dropdownStyle"
            :value="selected"
            :class="unset ? 'unset-width' : ''"
            @input="changedSelectedOption($event)"
        >
        </bo-dropdown-menu>

        <bo-numeric
            :class="['form-control', inputStyle]"
            :min="min"
            :max="getOrDefault(selected, 'max') ?? max"
            :negative="negative"
            :decimal="getOrDefault(selected, 'decimal')"
            :dynamic-min-decimal-place="getOrDefault(selected, 'min_decimal_place') ?? getOrDefault(selected, 'decimal')"
            :dynamic-decimal-place="true"
            :nullable="nullable"
            :value="value"
            :id="id"
            :editable="editable"
            @input="changedValue"
            @change="changedValue"
        ></bo-numeric>

        <bo-dropdown-menu
            v-if="!before"
            :disabled="!editable"
            :options="options"
            :dropdownStyle="dropdownStyle"
            :value="selected"
            @input="changedSelectedOption($event)"
        >
        </bo-dropdown-menu>
    </div>
</template>

<script>
import boDropdownMenu from "@/v2/components/bo-dropdown-menu.vue";
import boNumeric from "@/v2/components/bo-numeric.vue";
import { getOrDefault } from "@/v2/utils/object.js";

export default {
    components: { boDropdownMenu, boNumeric },
    props: {
        editable: {
            type: Boolean,
            default: false,
        },
        id: {
            type: String,
            default: "",
        },
        value: {
            type: [Number, String],
            default: null,
        },
        nullable: {
            type: Boolean,
            default: false,
        },
        inputStyle: {
            type: String,
            default: "",
        },
        options: {
            type: [Array, Object],
            default: [],
        },
        selected: {
            type: [Array, Object],
            default: [],
        },
        dropdownStyle: {
            type: String,
            default: "",
        },
        negative: {
            type: Boolean,
            default: true,
        },
        min: {
            type: Number,
            default: Number.MIN_SAFE_INTEGER,
        },
        max: {
            type: Number,
            default: Number.MAX_SAFE_INTEGER,
        },
        before: {
            type: Boolean,
            default: true,
        },
        unset: {
            type: Boolean,
            default: false,
        },
    },

    methods: {
        changedValue(value) {
            this.$emit("value_change", value);
        },
        changedSelectedOption(value) {
            this.$emit("selected_change", value);
        },
        getOrDefault(...args) {
            return getOrDefault(...args);
        },
    },
};
</script>
